import React, { useState } from "react";
import "./DesktopNotifications.css";
import { deleteNotificationApi, markAsReadNotificationApi, markAsUnReadNotificationApi } from "../../../utils/constants";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../utils/redux-store/appStore";

export interface Notification {
    _id: string;
    message: string;
    type: string;
    isRead: boolean;
    timestamp: Date;
    color: string;
}

const DesktopNotifications: React.FC = () => {
    const [filter, setFilter] = useState<"all" | "unread" | "read">("all");
    const [isSelectMode, setIsSelectMode] = useState(false);
    const [selectedNotifications, setSelectedNotifications] = useState<string[]>([]);
    const userProfile = useSelector((store: any) => store.login.loginDetails);
    const notifications = useSelector((store: RootState) => store.notifications.notifications);

    const filteredNotifications = [...notifications.read, ...notifications.unread].filter((notification) =>
        filter === "all" ? true : filter === "unread" ? !notification.isRead : notification.isRead
    );

    const markAsRead = async (ids: string[]) => {
        try {
            const payload = {
                "emailId": userProfile.email,
                "notificationIds": selectedNotifications
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            };

            const result: any = await (await fetch(markAsReadNotificationApi, options)).json();
            console.log('[RESULT ::]', result)
            if (result) {

            }
        } catch (err) {
            console.log('ERROR :::', err);
        }
    };

    const markAsUnRead = async (ids: string[]) => {
        try {
            const payload = {
                "emailId": userProfile.email,
                "notificationIds": selectedNotifications
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            };

            const result: any = await (await fetch(markAsUnReadNotificationApi, options)).json();
            console.log('[RESULT ::]', result)
            if (result) {

            }
        } catch (err) {
            console.log('ERROR :::', err);
        }
    };

    const deleteNotification = async (ids: string[]) => {
        try {
            const payload = {
                "emailId": userProfile.email,
                "notificationIds": selectedNotifications
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            };

            const result: any = await (await fetch(deleteNotificationApi, options)).json();
            console.log('[RESULT ::]', result)
            if (result) {

            }
        } catch (err) {
            console.log('ERROR :::', err);
        }
    };


    const toggleSelectNotification = (id: string) => {
        console.log('pDIID', id)
        setSelectedNotifications((prev) =>
            prev.includes(id) ? prev.filter((notifId) => notifId !== id) : [...prev, id]
        );
    };

    const toggleSelectAll = () => {
        if (selectedNotifications.length === filteredNotifications.length) {
            setSelectedNotifications([]);
        } else {
            setSelectedNotifications(filteredNotifications.map((notif) => notif._id));
        }
    };

    const formatTimestamp = (timestamp: string | Date) => {
        const date = new Date(timestamp);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const dd = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
    };


    return (
        <div className="notification-system">
            <h2 style={{ textAlign: "center", margin: "10px" }}>Notifications</h2>
            <div className="filter-buttons">
                {filteredNotifications.length > 0 && <div className="select-button" onClick={() => setIsSelectMode(!isSelectMode)}>
                    {isSelectMode ? "Cancel" : "Select"}
                </div>}
                <div className={`${filter === "all" ? "notifications-button-active" : ""} notifications-button`} onClick={() => setFilter("all")}>
                    All
                </div>
                <div className={`${filter === "unread" ? "notifications-button-active" : ""} notifications-button`} onClick={() => setFilter("unread")}>
                    Unread
                </div>
                <div className={`${filter === "read" ? "notifications-button-active" : ""} notifications-button`} onClick={() => setFilter("read")}>
                    Read
                </div>
            </div>
            {isSelectMode && filteredNotifications.length > 0 && (
                <div className="bulk-actions">
                    <div className="bulk-actions-button" onClick={() => markAsRead(selectedNotifications)} style={{
                        backgroundColor: selectedNotifications.length > 0 ? "#34b77a" : "#b3b5b9",
                        cursor: selectedNotifications.length > 0 ? "pointer" : "not-allowed",
                        opacity: selectedNotifications.length > 0 ? 1 : 0.6,
                        width: 'fit-content',
                    }}>
                        Mark as Read
                    </div>
                    <div className="bulk-actions-button" onClick={() => markAsUnRead(selectedNotifications)} style={{
                        backgroundColor: selectedNotifications.length > 0 ? "#4d848f" : "#b3b5b9",
                        cursor: selectedNotifications.length > 0 ? "pointer" : "not-allowed",
                        opacity: selectedNotifications.length > 0 ? 1 : 0.6,
                        width: 'fit-content',
                    }}>
                        Mark as Unread
                    </div>
                    <div className="bulk-actions-button"
                        onClick={() => {
                            if (selectedNotifications.length > 0) deleteNotification(selectedNotifications);
                        }}
                        style={{
                            width: 'fit-content',
                            backgroundColor: selectedNotifications.length > 0 ? "#e52033" : "#b3b5b9",
                            cursor: selectedNotifications.length > 0 ? "pointer" : "not-allowed",
                            opacity: selectedNotifications.length > 0 ? 1 : 0.6,
                        }}
                    >
                        Delete
                    </div>

                    <div className="bulk-actions-button" style={{
                        width: 'fit-content',
                        backgroundColor: "#8077a3"
                    }} onClick={toggleSelectAll}>
                        {selectedNotifications.length === filteredNotifications.length ? "Deselect All" : "Select All"}
                    </div>
                </div>
            )}

            <ul className="notification-list">
                {filteredNotifications.length === 0 ? (
                    <p style={{ textAlign: "center", marginTop: "100px" }}>No notifications to display</p>
                ) : (
                    filteredNotifications.map((notif) => (
                        <li
                            key={notif._id}
                            className={`notification-item ${notif.isRead ? "read" : "unread"}`}
                            onClick={() => toggleSelectNotification(notif._id)}
                        >
                            {isSelectMode && (
                                <input
                                    type="checkbox"
                                    checked={selectedNotifications.includes(notif._id)}
                                    onClick={(e) => e.stopPropagation()} // Prevent checkbox click from triggering parent click
                                    onChange={() => toggleSelectNotification(notif._id)}
                                    style={{ width: "fit-content" }}
                                />
                            )}
                            <div className="notification-content" style={{ position: "relative" }}>
                                <p dangerouslySetInnerHTML={{ __html: notif.message }}></p>
                                <small>{formatTimestamp(notif.timestamp)}</small>

                                {/* Tag */}
                                <div className="notification-tag" style={{ backgroundColor: notif.color }}>
                                    {notif.type}
                                </div>
                            </div>

                        </li>
                    ))
                )}
            </ul>
        </div>
    );
};

export default DesktopNotifications;
